import { useEffect, useRef } from 'react';

import { buildIframeReadyMetrics, getReportContext, HOST_METRICS_PARAMS, parseQuery } from '../utils';

interface UseIframeReadyMetricsParams {
  readyAt: number | null;
  initDuration?: number;
}

export const useIframeReadyMetrics = ({ readyAt, initDuration }: UseIframeReadyMetricsParams) => {
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current || !readyAt) return;

    const { sessionId, requestUrl } = getReportContext();
    const query = parseQuery(window.location.search);
    const asString = (value: unknown) => (value === undefined ? undefined : `${value}`);

    const metrics = buildIframeReadyMetrics({
      readyAt,
      // Back-dated to the render that took `readyAt`
      readyAtEpoch: Date.now() - (performance.now() - readyAt),
      initDuration,
      metricsParam: asString(query.metrics),
      sessionId,
      hostStartedAt: asString(query[HOST_METRICS_PARAMS.startedAt]),
      urlDuration: asString(query[HOST_METRICS_PARAMS.urlDuration]),
    });

    if (!metrics) return;

    sentRef.current = true;

    fetch(requestUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'X-Session-Id': sessionId,
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        metrics,
        tags: { flow: 'init' },
      }),
      keepalive: true,
    }).catch(() => {
      // Non-critical
    });
  }, [readyAt, initDuration]);
};
